import script from "./TornadoTransition.vue?vue&type=script&setup=true&lang=js"
export * from "./TornadoTransition.vue?vue&type=script&setup=true&lang=js"

import "./TornadoTransition.vue?vue&type=style&index=0&id=4ffeffc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ffeffc3"]])

export default __exports__